import React from 'react';
import { observer } from 'mobx-react-lite';
import { FreeBetsWrapper } from '@pascal/pascal-core';

import ReBet from '../../reBet';
import MobileSceneViewWithProps from './MobileSceneViewWithProps';


const MobileScene = observer(
  ({
    isOpenBetPopup,
    totalBetForNote,
    setIsOpenBetPopup,
    setTotalBetForNote,
    isOpenCashOutPopup,
    setIsOpenCashOutPopup,
  }) => {
    return (
      <div className='m-c-m-actions-holder'>
        <div className='m-c-m-actions-holder-inner'>
          <div className='top-m-c-m-action-item-holder'>
            <div className='top-m-c-m-action-item-holder-inner'>
              <MobileSceneViewWithProps
                itemId={1}
                isOpenBetPopup={isOpenBetPopup}
                totalBetForNote={totalBetForNote}
                setIsOpenBetPopup={setIsOpenBetPopup}
                setTotalBetForNote={setTotalBetForNote}
                isOpenCashOutPopup={isOpenCashOutPopup}
                setIsOpenCashOutPopup={setIsOpenCashOutPopup}
              />
            </div>
          </div>
          <FreeBetsWrapper />
          <div className='m-c-m-action-item'>
            <MobileSceneViewWithProps
              itemId={0}
              isOpenBetPopup={isOpenBetPopup}
              totalBetForNote={totalBetForNote}
              setIsOpenBetPopup={setIsOpenBetPopup}
              setTotalBetForNote={setTotalBetForNote}
              isOpenCashOutPopup={isOpenCashOutPopup}
              setIsOpenCashOutPopup={setIsOpenCashOutPopup}
            />
          </div>
          <div className='m-c-m-rebet-item-holder'>
            <ReBet />
          </div>
          <div className='m-c-m-action-item'>
            <MobileSceneViewWithProps
              itemId={2}
              isOpenBetPopup={isOpenBetPopup}
              totalBetForNote={totalBetForNote}
              setIsOpenBetPopup={setIsOpenBetPopup}
              setTotalBetForNote={setTotalBetForNote}
              isOpenCashOutPopup={isOpenCashOutPopup}
              setIsOpenCashOutPopup={setIsOpenCashOutPopup}
            />
          </div>
        </div>
      </div>
    );
  }
);

export default MobileScene;
